import styled, { css } from 'styled-components';
import { Box } from '../../../Box';
import { TableData } from '../TableData/TableData';

var computeRowBackground = function computeRowBackground(theme, selected) {
  var customColor = theme.colors.primary.lighter;
  return css(["background-color:", ";&:hover,&:hover > td{background-color:", ";}"], selected ? customColor : 'white', selected ? customColor : theme.colors.grey.lighter);
};

export var TableRow = styled(Box).attrs({
  as: 'tr'
}).withConfig({
  displayName: "styled__TableRow",
  componentId: "sc-1xks1gd-0"
})(function (_ref) {
  var theme = _ref.theme,
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? false : _ref$selected,
      disabled = _ref.disabled,
      clickable = _ref.clickable;
  return css(["display:table-row;", " ", " ", ""], computeRowBackground(theme, selected), disabled ? css(["pointer-events:none;opacity:0.6;cursor:default;"]) : '', clickable ? css(["cursor:pointer;"]) : '');
});
export var ActionsTableData = styled(TableData).withConfig({
  displayName: "styled__ActionsTableData",
  componentId: "sc-1xks1gd-1"
})(function (_ref2) {
  var space = _ref2.theme.space;
  return "\n  padding: 0 " + space.xxxs + "px;\n  width: 40px;\n";
});
export var SkeletonWrapper = styled.div.withConfig({
  displayName: "styled__SkeletonWrapper",
  componentId: "sc-1xks1gd-2"
})(["flex:1;"]);